module.exports = __webpack_public_path__ + "static/media/pembatalan_siswa_keluar.2a91a250.png";